import { render, staticRenderFns } from "./leavePlanning.vue?vue&type=template&id=28a172f2"
import script from "./leavePlanning.vue?vue&type=script&lang=js"
export * from "./leavePlanning.vue?vue&type=script&lang=js"
import style0 from "./leavePlanning.vue?vue&type=style&index=0&id=28a172f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports